var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useMutation, useQueryClient } from 'react-query';
import { CacheKeys } from '../constants';
import { useChuckClientContext } from './useChuckClientContext';
import { useAPI } from './useAPI';
export const useTemplateUpdate = () => {
    const queryClient = useQueryClient();
    const { patch } = useAPI();
    const { client } = useChuckClientContext();
    return useMutation((_a) => {
        var { id } = _a, data = __rest(_a, ["id"]);
        return patch({ url: `/templates/${id}`, data }).then((res) => res.data);
    }, {
        onSuccess: (data) => {
            const prev = queryClient.getQueryData(CacheKeys.TEMPLATES);
            queryClient.setQueryData(CacheKeys.TEMPLATES, prev
                ? prev.map((template) => template.id === data.id ? data : template)
                : [data]);
        },
        onError: (err) => {
            client.captureException(err);
        }
    });
};
//# sourceMappingURL=useTemplateUpdate.js.map